import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    credentials: 'include',
    'Access-Control-Allow-Methods': '*',
  },
});

export const getAccessToken = async (EMAIL, TOKEN) => {
  let REQ_BODY = {
    email: EMAIL,
    token: TOKEN,
  };

  let URL = `/user/generateauthtoken`;

  try {
    const response = await instance.post(URL, REQ_BODY);
    return response.data;
  } catch (error) {
    throw error;
  }
};
